import { faClose, faGear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import Nav from 'components/general/Nav';
import { width } from 'components/general/Nav/styles';
import StyledDivider from 'components/general/StyledDivider';
import { IUrlParams } from 'components/general/types';
import ViewContainer from 'components/general/ViewContainer';
import ViewPort from 'components/general/ViewPort';
import LoadingView from 'components/LoadingView';
import _ from 'lodash';
import { ActiveBranchContext } from 'providers';
import { useContext, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { ModuleVables, TModuleType } from 'utils/vable';
import CADModelPanel from './CADModelPanel';
import FloatingWidget from './CADModelPanel/FloatingWidget';
import EditBoards from './EditBoards';
import useStyles from './styles';

const AgentTemplateEditView = () => {
  const { branch } = useContext(ActiveBranchContext);
  const { classes } = useStyles();
  const { moduleAction } = useParams<IUrlParams>();
  const moduleCaps = _.upperCase(moduleAction).replace(' ', '_') as TModuleType;

  const [openPanel, setOpenPanel] = useState(false);
  const anchorEl = useRef<HTMLDivElement>(null);

  if (!branch.model?.ready) return <LoadingView />;

  return (
    <ViewContainer>
      <Nav
        contextElement={
          <>
            <div ref={anchorEl} className="joyride-model-view" style={{ height: '200px' }}>
              <IconButton
                className={classes.openPanelButton}
                onClick={() => setOpenPanel((prev) => !prev)}
              >
                <FontAwesomeIcon icon={openPanel ? faClose : faGear} />
              </IconButton>
            </div>
            <FloatingWidget
              open={openPanel}
              keepMounted
              initPosition={{ x: width + 8, y: 8 }}
              style={{ zIndex: 1001 }}
            >
              <div className={classes.cadPanelWrapper}>
                <div className={classes.cadHeader}>
                  <h3>CAD Model</h3>
                  <IconButton style={{ width: 30, height: 30 }} onClick={() => setOpenPanel(false)}>
                    <FontAwesomeIcon icon={faClose} />
                  </IconButton>
                </div>
                <StyledDivider />
                <CADModelPanel
                  portalContainer={anchorEl}
                  disablePortal={openPanel}
                  onClose={() => setOpenPanel(false)}
                />
              </div>
            </FloatingWidget>
          </>
        }
        contextName={
          <h1 className={classes.navContextName}>
            {openPanel ? ModuleVables.ModuleTypes[moduleCaps].label : <></>}
          </h1>
        }
      />
      <ViewPort minWidth={650}>
        <EditBoards />
      </ViewPort>
    </ViewContainer>
  );
};

export default AgentTemplateEditView;
